// extracted by mini-css-extract-plugin
export default {"box":"SettlementManage_box__t8ogw","table":"SettlementManage_table__cT+Pp","action":"SettlementManage_action__Kxxqh","menuItemActive":"SettlementManage_menuItemActive__+xEDW"};